import { render, staticRenderFns } from "./OvertimeComponent.vue?vue&type=template&id=2fb5e5c0&scoped=true"
import script from "./OvertimeComponent.vue?vue&type=script&lang=js"
export * from "./OvertimeComponent.vue?vue&type=script&lang=js"
import style0 from "./OvertimeComponent.vue?vue&type=style&index=0&id=2fb5e5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb5e5c0",
  null
  
)

export default component.exports